import angular from "angular";
import Spinner from "./Spinner";
import ErrorMessage from "./ErrorMessage";
import OnFile from "./OnFile";
import FileService from "./FileService";

export default angular.module("energis.util", [])
.directive("spinner", Spinner)
.directive("errorMessage", ErrorMessage)
.directive("onFile", OnFile)
.service("FileService", FileService)
.name;


export function array_remove(array, element){
  var index = array.indexOf(element);
  if(index >= 0){
    array.splice(index, 1);
  }
}

export function Worker(job){
  var busy = WorkIndicator();
  var hasFailed = false;
  var lastError = undefined;
  var done = false;
  var fn = function(){
    hasFailed = false;
    done = false;
    busy.work();
    var result = job.apply(this, arguments);
    if(result && result.then){
      result = result.then(
        x => {busy.done(); done = true; return x;}, 
        err => {hasFailed = true; busy.done(); lastError = err; throw err;}
      )
    }else{
      done = true;
      busy.done();
    }
    return result;
  }
  fn.isWorking = busy.isWorking;
  fn.hasFailed = function(){ return hasFailed; }
  fn.getError = function(){ return lastError;}
  fn.isDone = function(){
    return done;
  }
  return fn;
}

export function WorkIndicator(){
  var self = {
    workQueue: 0,
    working: false,
    isWorking: function(){
      return self.working;
    },
    work: function(){
      self.workQueue++;
      self.working = self.workQueue > 0;
    },
    done: function(){
      if(self.working){
        self.workQueue--;
        self.working = self.workQueue > 0;
      }
    },
    finish: function(){
      self.working = false;
      self.workQueue = 0;
    }
  }
  return self;
}

export function strcmp ( str1, str2 ) {
    return ( ( str1 == str2 ) ? 0 : ( ( str1 > str2 ) ? 1 : -1 ) );
}



// WEBPACK FOOTER //
// ./src/util/index.js